import { render, staticRenderFns } from "./BnTeaorInput.vue?vue&type=template&id=43d91db7&"
import script from "./BnTeaorInput.vue?vue&type=script&lang=js&"
export * from "./BnTeaorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports